import styled from 'styled-components';
import { Box } from 'pcln-design-system';
export const LoadMoreContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "LoadMorestyles__LoadMoreContainer",
  componentId: "sc-sw8f2i-0"
})(["height:455px;border:1px dotted rgba(224,229,234,1);border-radius:16px;width:166px;"]);
export const LinkContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "LoadMorestyles__LinkContainer",
  componentId: "sc-sw8f2i-1"
})(["cursor:pointer;"]);